if(typeof _.now === 'undefined') { var e = new Error("Cannot find module '_.now'"); e.code = 'MODULE_NOT_FOUND'; throw e; }

module.exports = _.now;